var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M23.3467 11.4289C23.3467 10.4979 22.8365 9.6938 22.086 9.25726V3.23437C22.086 2.88963 21.811 1.97321 20.8252 1.97321C20.5447 1.97321 20.2662 2.06698 20.038 2.24979L16.688 4.93009C15.0052 6.27517 12.8927 7.01626 10.7391 7.01626H3.17456C1.78181 7.01626 0.653035 8.14503 0.653035 9.53778V13.3201C0.653035 14.7128 1.78181 15.8416 3.17456 15.8416H4.5023C4.44753 16.2545 4.41641 16.6745 4.41641 17.1024C4.41641 18.6692 4.78124 20.1498 5.42344 21.4733C5.62792 21.8944 6.07431 22.1454 6.54237 22.1454H9.46891C10.4952 22.1454 11.1114 20.9697 10.4893 20.1534C9.8432 19.3055 9.45906 18.2481 9.45906 17.1024C9.45906 16.6646 9.52289 16.2439 9.63281 15.8416H10.7391C12.8927 15.8416 15.0052 16.5827 16.6876 17.9278L20.0376 20.6081C20.2611 20.7869 20.5387 20.8844 20.8248 20.8846C21.8066 20.8846 22.0856 19.9871 22.0856 19.6239V13.601C22.8365 13.164 23.3467 12.3599 23.3467 11.4289ZM19.5645 17.0007L18.2623 15.959C16.1348 14.257 13.4624 13.3201 10.7391 13.3201V9.53778C13.4624 9.53778 16.1348 8.60088 18.2623 6.89885L19.5645 5.85715V17.0007Z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }